export const ROUTES = {
  LOGIN: '/login',

  DASHBOARD: '/dashboard',

  USERS: '/users',
  USER_DETAIL: '/users/:id',

  PROFILES: '/profiles',

  MATCHES: '/matches',
  MATCH_REQUESTS: '/match-requests',

  GAMES: '/games',
  GAME_DETAIL: '/games/:id',
  GAME_REVIEW: '/games/review',

  PINS: '/pins',

  LEAGUES: '/leagues',

  POSTS: '/posts',
  REPORTS: '/reports',

  RANKINGS: '/rankings',

  NOTIFICATIONS: '/notifications',

  STATISTICS: '/statistics',
  SCREEN_ANALYTICS: '/screen-analytics',

  SETTINGS_ACCOUNTS: '/settings/accounts',
  SETTINGS_SYSTEM: '/settings/system',
  SETTINGS_VERSION_LOGS: '/settings/version-logs',
  SETTINGS_PUSH_CAMPAIGNS: '/settings/push-campaigns',

  TEAMS: '/teams',
  TEAM_DETAIL: '/teams/:id',
  TEAM_MATCHES: '/team-matches',

  NOTICES: '/notices',

  DISPUTES: '/disputes',

  INQUIRIES: '/inquiries',

  NOSHOW_REPORTS: '/noshow-reports',

  LANDING_STATS: '/landing-stats',

  ALERT_STATS: '/alert-stats',
  ALERT_HOLIDAYS: '/alert-holidays',
} as const;
